// Libs
import classNames from 'classnames/bind';
import { Box } from '@mui/material';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { BaseTable } from '~/components/common';
// Others
import { IHeaderCellType } from '~/utils/interface/common';
import { BusinessModelEnum } from '~/utils/enum/common';
import { EMPTY_STRING } from '~/utils/constants/common';
import { formatTitleCase } from '~/utils/helper/common';
import { IActivity, IActivityDetail } from '~/utils/interface/activity';
// Styles, images, icons
import styles from './ActivityDetailTable.module.scss';

type Props = {
  data: IActivity;
};

const cx = classNames.bind(styles);

const columnsDefault = (t: TFunction): IHeaderCellType<IActivityDetail>[] => {
  return [
    {
      id: 'name',
      label: t('activity_detail_table_title_name'),
      render: (record: IActivityDetail) => formatTitleCase(record?.name),
    },
    {
      id: 'oldValue',
      label: t('activity_detail_table_title_old_value'),
      minWidth: 100,
      render: (record: IActivityDetail) =>
        record?.oldValue?.[0]?.display != null ? String(record?.oldValue?.[0]?.display) : EMPTY_STRING,
    },
    {
      id: 'newValue',
      label: t('activity_detail_table_title_new_value'),
      render: (record: IActivityDetail) =>
        record?.newValue?.[0]?.display != null ? String(record?.newValue?.[0]?.display) : EMPTY_STRING,
    },
  ];
};

const ActivityDetailTable = (props: Props) => {
  //#region Destructuring Props
  const { data } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/activity', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const renderColumnsTable = () => {
    switch (data?.businessModel) {
      // case BusinessModelEnum.INVENTORY:
      //   return columnsInventory(t);

      default:
        return columnsDefault(t);
    }
  };
  //#endregion Handle Function

  return (
    <Box id={'activityDetailTableComponent'}>
      <BaseTable columns={renderColumnsTable()} dataSource={data?.detail || []} />
    </Box>
  );
};

export default ActivityDetailTable;
